import { render, staticRenderFns } from "./Pageloader.vue?vue&type=template&id=a014f26c&"
import script from "./Pageloader.vue?vue&type=script&lang=js&"
export * from "./Pageloader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports